/* eslint-disable @typescript-eslint/no-explicit-any */
import { Heading, RichText, Types } from '@marriott/mi-ui-library';
import { EditableComponent, ResponsiveGrid } from '@adobe/aem-react-editable-components';
import clsx from 'clsx';
import { PropertyDetails } from '../PropertyDetails';
import { StyledRecommendationsContainer, StyledRecommendationsCourses } from './RecommendationsContainer.styles';
import { fullbleedClass } from '../../modules/utils/constants/constants';
const { NEXT_PUBLIC_AEM_SITE } = process.env;

export const RecommendationsContainer = (props: any) => {
  const {
    header,
    headerTag,
    styleclass,
    componentId,
    headerFontSize,
    descriptionText,
    descFontSize,
    desktopColumns,
    tabletColumns,
    mobileColumns,
    isAuthorMode,
    itemPath,
    pagePath,
  } = props;

  // This function is used to render the component in authoring mode authorComponentWrapper
  const authorComponentWrapper = (index: number) => {
    return (
      <ResponsiveGrid
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        pagePath={pagePath}
        itemPath={`${itemPath}/card-${index}`}
        columnCount="12"
        gridClassNames={''}
        customClassName={''}
        config={{
          isEmpty: () => true,
          resourceType: 'mi-aem-common-spa/components/container',
        }}
      />
    );
  };

  // This function is used to render the component in end-user mode
  const publishComponentWrapper = (index: number) => {
    const propertyDetailsProps = props?.[':items']?.[`card-${index}`][':items'].propertyDetails;
    return <PropertyDetails {...propertyDetailsProps} />;
  };

  return (
    <StyledRecommendationsContainer
      data-component-name="m-rnb-RecommendationsContainer"
      data-testid="rnb-RecommendationsContainer"
      className={clsx(styleclass, 'pt-3 pb-5 ')}
    >
      <div
        className={clsx('container recommendations-container', {
          'px-md-0': props?.styleclass?.includes(fullbleedClass),
          'p-0': !props?.styleclass?.includes(fullbleedClass),
        })}
      >
        {header && (
          <Heading
            customClass={clsx(headerFontSize, 'mb-2', 'recommendations-header')}
            variation={Types.headingType.subtitle}
            fontSize={headerFontSize}
            element={headerTag}
            dangerouslySet={header}
          />
        )}

        {descriptionText && (
          <RichText
            text={descriptionText}
            customClass={clsx(descFontSize, 'recommendations-description')}
            componentId={componentId + '-DescriptionText'}
          />
        )}

        <StyledRecommendationsCourses
          desktopColumns={desktopColumns}
          tabletColumns={tabletColumns}
          mobileColumns={mobileColumns}
          className="py-5"
        >
          {isAuthorMode &&
            Array.from({ length: Object.keys(props?.cqItems).length }, (_, ind) => (
              <div>{authorComponentWrapper(ind)}</div>
            ))}

          {!isAuthorMode &&
            Array.from({ length: Object.keys(props?.[':items']).length }, (_, ind) => (
              <div>{publishComponentWrapper(ind)}</div>
            ))}
        </StyledRecommendationsCourses>
      </div>
    </StyledRecommendationsContainer>
  );
};

export const RecommendationsContainerConfig = {
  emptyLabel: 'recommendationscontainer',
  isEmpty: false,
  resourceType: `${NEXT_PUBLIC_AEM_SITE}/components/content/golf/recommendationscontainer`,
};

export const RecommendationsContainerEditable = (props: any) => (
  <EditableComponent config={RecommendationsContainerConfig} {...props}>
    <RecommendationsContainer {...props} />
  </EditableComponent>
);
